module.exports = __webpack_public_path__ + "static/media/mglx1.043e066d.jpg";